import { Breadcrumb, Button, Col, Row, Steps, message } from "antd";
import "../ep.scss";
import "./epPrefactor.scss";
import { _adr } from "../../../../address";
import { HomeOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { Content } from "antd/es/layout/layout";
import { complexDigitToman, formatMsisdn, isEmpty } from "../../../../tools/tools";
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useAPIPublic, useDealer } from "../../../../tools/api";
import Loading from "../../../auxiliary/loader/loading";
import IncressCharge from "../../../auxiliary/incressCharge/charge";
import { globalValue } from "../../../../reducer/serviceReducerGlobala";
import { switchPlanID } from "../../../../tools/services";
import Profile from "../../../corporate_subscriber_search/corporate/profile/profile";
const EPPrefactor = () => {
	const [t] = useTranslation("global");
	const { queryTaxPercent } = useAPIPublic();
	const { completeEPPurchase } = useDealer();
	const [searchParam] = useSearchParams();
	const nav = useNavigate();
	const formData = useSelector((state) => state);
	const dispatch = useDispatch();

	const [wallet, setWallet] = useState(0);
	const location = useLocation();
	const [openIncress, setOpenIncress] = useState();
	const [tax, setTax] = useState(0);
	const [taxPrice, setTaxPrice] = useState(0);
	const [totalPrice, setTotalPrice] = useState(0);
	const [localInvoiceId, setLocalInvoiceId] = useState("");
	const [isLoading, setIsLoading] = useState(false);
	const [commisionDc, setCommisionDc] = useState(0);
	const [commissionPrice, setCommissionPrice] = useState(0);
	const [totalPriceWallet, setTotalPriceWallet] = useState(0);
	const [messageApi, contextHolder] = message.useMessage();

	const bankRef = useRef("");

	useEffect(() => {
		try {
			if (!isEmpty(searchParam.get("localInvoiceId"))) {
				const getLocalInvoiceID = searchParam.get("localInvoiceId");
				setLocalInvoiceId(getLocalInvoiceID);
				setOpenIncress(true);
				location.state = formData?.another?.epPackage;
			}
		} catch (error) {
			console.error(error);
		}
	}, []);

	useEffect(() => {
		try {
			setWallet(formData?.another?._currentUser?.walletAmount);
			setCommisionDc(formData?.another?._currentUser?.cpcommission);
		} catch (error) {
			console.error(error);
		}
	}, [formData?.another?._currentUser?.walletAmount]);

	useEffect(() => {
		const initialServ = async () => {
			try {
				if (tax === 0) {
					let resTax = await queryTaxPercent();
					if (resTax) setTax(resTax);
				}
			} catch (error) {
				console.error(error);
			}
		};
		initialServ();
	}, []);

	useEffect(() => {
		if (tax > 0) calcPrice();
	}, [tax]);

	const calcPrice = () => {
		try {
			let chargeAmount = location?.state?.package.packagePrice;
			let taxPrice = (chargeAmount * tax) / 100;
			setTaxPrice(taxPrice);
			setTotalPrice(chargeAmount + taxPrice);
			setCommissionPrice(((chargeAmount + taxPrice) * commisionDc) / 100);
			let commission = Math.round(((chargeAmount + taxPrice) * commisionDc) / 100);
			let total = Math.round(chargeAmount + taxPrice - commission);
			setTotalPriceWallet(total);
		} catch (error) {
			console.error(error);
		}
	};
	const handleCallBackCharge = (value) => {
		try {
			if (value?.length > 0) {
				dispatch(globalValue({ epPackage: { ...location?.state } }));
				bankRef.current.innerHTML = value;
				document.querySelector('form[action="https://asan.shaparak.ir"]').submit();
			} else {
				setLocalInvoiceId("");
				setOpenIncress(false);
			}
		} catch (error) {
			console.error(error);
		}
	};

	const handleSubmit = async () => {
		try {
			setIsLoading(true);
			if (wallet - totalPriceWallet >= 0) {
				let payload = {
					msisdn: location?.state?.msisdn,
					planid: switchPlanID().extraPackage,
					packagecode: location?.state?.package?.packageCode,
				};
				let response = await completeEPPurchase(payload);
				if (response) {
					nav(_adr.Root + _adr.EPPurchase.Index + _adr.EPPurchase.Shop + _adr.EPPurchase.Final, {
						state: { ...response, purchase: location?.state?.purchase || null },
					});
				}
			} else {
				messageApi.open({
					type: "error",
					content: "موجودی کیف پول کافی نمی باشد.",
				});
			}
			setIsLoading(false);
		} catch (error) {
			console.error(error);
			setIsLoading(false);
		}
	};
	const switchSpecialType = (keyVal, specialKey) => {
		try {
			if (keyVal === 1) {
				return <span className="internet">بسته اینترنت</span>;
			}
			if (keyVal === 2) {
				return <span className="combo">بسته ترکیبی</span>;
			}
			if (specialKey === 2) {
				return <span className="roaming">رومینگ عراق</span>;
			}
			if (specialKey === 1) {
				return <span className="roaming">رومینگ ترکیه</span>;
			}
		} catch (error) {
			console.error(error);
		}
	};
	return (
		<>
			<div className="container-main container-ep">
				{contextHolder}
				<div className="g-hold-title-of-page">
					<Breadcrumb
						className="breadcrumbs"
						items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("extraPackage.title") }]}
					/>
					<div className="title-page">
						<h3>{t("extraPackage.title")}</h3>
						<p></p>
					</div>
				</div>
				<div className="g-layout-content">
					<Content className="g-layout-main ep-container">
						<div className="g-format-page">
							{location?.state?.purchase && (
								<>
									<Profile Profile={location?.state?.purchase} state />
									<br />
								</>
							)}
							<div className="g-body-format-page">
								<div className="g-format-steps">
									<div className="holder-step">
										<Steps
											size="small"
											className="step-wizard"
											current={1}
											items={[
												{
													title: "انتخاب بسته",
												},
												{
													title: "پیش فاکتور",
												},
												{
													title: "رسید",
												},
											]}
										/>
									</div>
								</div>
								<div className="g-prefactor">
									<div className="holder-row-prefactor">
										<Row gutter={16}>
											<Col span={14} xl={14} lg={14} md={24} sm={24} xs={24}>
												<div className="for-pay-client">
													<h3>صورت حساب مشتری</h3>
													<div className="holder-box">
														<div className="holder-simcard">
															<div className="holder-list-msisdn">
																<div className="item">
																	<div className="row-item">
																		<div className="holder-icon">
																			<i className="icon-simcard"></i>
																		</div>
																		<div className="holder-text">
																			<h4>
																				ﺳﯿﻢ‌ﮐﺎﺭﺕ ﺍﻋﺘﺒﺎﺭﯼ ﺑﺎ ﺷﻤﺎﺭﻩ <span dir="ltr">{location?.state?.msisdn}</span>
																			</h4>
																			<p></p>
																		</div>
																		<div className="holder-option"></div>
																	</div>
																</div>
															</div>
														</div>
														<div className="divider"></div>
														<div className="holder-profile">
															<h4>مشخصات بسته </h4>
															<div className="list-item">
																<div className="item">
																	<div className="label">نوع بسته:</div>
																	<div className="value">
																		<span dir="ltr">
																			{switchSpecialType(location?.state?.package?.packageType, location?.state?.package?.specialPackageType)}
																		</span>
																	</div>
																</div>
																<div className="item">
																	<div className="label">قیمت:</div>
																	<div className="value">
																		<span dir="ltr">{complexDigitToman(location?.state?.package?.packagePrice)}</span> تومان
																	</div>
																</div>
																<div className="item">
																	<div className="label">مشخصات:</div>
																	<div className="value">
																		<span>
																			{location?.state?.package?.packageName}
																			{location?.state?.package?.voiceCallInDoorDescription !== "0 دقیقه" && (
																				<>
																					+{location?.state?.package?.voiceCallInDoorDescription}
																					{location?.state?.package?.packageType === 12 ? (
																						<> مکالمه با خطوط ترکیه</>
																					) : (
																						<> مکالمه آپتلی و غیرآپتلی</>
																					)}{" "}
																				</>
																			)}
																			{location?.state?.package?.smsDescription !== "0 عدد" && location?.state?.package?.smsDescription !== "0" && (
																				<>
																					+{location?.state?.package?.smsDescription}
																					{location?.state?.package?.packageType === 12 ? <> پیامک به ایران</> : <> پیامک</>}{" "}
																				</>
																			)}
																		</span>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</Col>
											<Col span={10} xl={10} lg={10} md={24} sm={24} xs={24}>
												<div className="for-pay-agent">
													<h3>صورت حساب فروشنده</h3>
													<div className="holder-box">
														<div className="holder-list-pay">
															<ul>
																<li>
																	<div className="label">مبلغ بسته</div>
																	<div className="value">
																		<span dir="ltr">{complexDigitToman(location?.state?.package?.packagePrice)}</span> <small>تومان</small>
																	</div>
																</li>
																<li>
																	<div className="label">مالیات ({tax}درصد)</div>
																	<div className="value">
																		<span dir="ltr">{complexDigitToman(taxPrice)}</span> تومان
																	</div>
																</li>

																<li>
																	<div className="label">مبلغ قابل دریافت از مشتری</div>
																	<div className="value">
																		<span dir="ltr">{complexDigitToman(totalPrice)}</span> تومان
																	</div>
																</li>
																<li>
																	<div className="label">مبلغ سود شما از فروش</div>
																	<div className="value">
																		<span dir="ltr">{complexDigitToman(commissionPrice)}</span> تومان
																	</div>
																</li>
																<li>
																	<div className="label">مبلغ برداشت از کیف پول</div>
																	<div className="value">
																		<span dir="ltr">
																			{/* {complexDigitToman(totalPrice)} */}
																			{complexDigitToman(totalPriceWallet)}
																		</span>{" "}
																		تومان
																	</div>
																</li>
															</ul>
															{wallet - totalPriceWallet >= 0 ? (
																<div className="hold-message success">
																	<p>این مبلغ از کیف پول شما برداشت می‌شود</p>
																	<h3>
																		{" "}
																		<span dir="ltr">
																			{/* {complexDigitToman(Math.abs(totalPrice))} */}
																			{complexDigitToman(totalPriceWallet)}
																		</span>{" "}
																		تومان
																	</h3>
																</div>
															) : (
																<div className="hold-message error">
																	<div className="row-message">
																		<div className="holder-text">
																			<h3>اعتبار شما کافی نمی‌باشد</h3>
																			<ul>
																				<li>
																					<div className="label">کسری اعتبار: </div>
																					<div className="value">
																						<span dir="ltr">
																							{/* {complexDigitToman(
                                                Math.abs(totalPrice - wallet)
                                              )} */}
																							{complexDigitToman(wallet - totalPriceWallet)}
																						</span>{" "}
																						تومان
																					</div>
																				</li>
																			</ul>
																		</div>
																		<div className="holder-acction">
																			<div className="holder-button">
																				<Button className="btn-normal btn-aptel" htmlType="button" onClick={() => setOpenIncress(true)}>
																					افزایش اعتبار
																				</Button>
																			</div>
																		</div>
																	</div>
																</div>
															)}
														</div>
													</div>
												</div>
											</Col>
										</Row>
									</div>
								</div>
							</div>
							<div className="g-footer-format-page">
								<div className="holder-button">
									<Button className="btn-normal btn-aptel" type="primary" danger onClick={handleSubmit}>
										مرحله بعد
									</Button>
									<Button
										type="default"
										className="btn-normal"
										onClick={() => nav(_adr.Root + _adr.EPPurchase.Index + _adr.EPPurchase.Shop + _adr.EPPurchase.Valid)}>
										بازگشت
									</Button>
								</div>
							</div>
						</div>
					</Content>
				</div>
			</div>

			<IncressCharge
				open={openIncress}
				planid={process.env.REACT_APP_PLANID_CHARGE_WALLET_EP}
				msisdn={formData?.another?._currentUser?.telnoone}
				price={Math.abs(wallet - totalPriceWallet)}
				callback={handleCallBackCharge}
				localInvoiceId={localInvoiceId}
			/>

			<Loading isOpen={isLoading} />
			<div ref={bankRef}></div>
		</>
	);
};

export default EPPrefactor;
